<template>
    <div>
       <BreadCrumb :data="breadCrumb" /> 
       <b-card class="Reports">
           <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <b-form v-else class="formBox" v-for="(field,i) in fields" :key="field">
                <div style="border-bottom: 1px solid #ccc; text-align:left">
                    <h4> {{ i }} </h4> 
                </div>
                <div style="display:flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                    <div style="margin: .5rem; width: 300px; display: flex;justify-content: flex-start; align-items: center;" v-for="f in field" :key="f.id">
                        <strong style="margin: .5rem"> {{f['db-column-name']}} </strong>
                        <b-input style="width: 200px;" v-model="f['attribute-name']"/>
                    </div>
                </div>      
            </b-form>
            <template v-slot:footer >
                <div style="display:flex; justify-content: flex-end; align-items: flex-end ">
                    <b-button variant="primary"  @click="saveData" >{{$t('general.save')}}</b-button>
                </div>

            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import _ from 'lodash'

    let breadCrumb = [
        { label: "Tanmlamalar", url: "/Definations" },
        { label: "AD Alan Yönetimi", url: "/Definations/ADManager" },
    ]

    export default {
        name: 'ADManager',
        created: async function(){
            await this.$store.dispatch("adfields_get")
        },
        computed: {
            loading(){
                return this.$store.getters.getLDAPLoading
            },
            fields(){
                return this.$store.getters.getADFields
            },
           
        },
        data:function(){
            return{
                breadCrumb
            }
        },
        components:{
            BreadCrumb
        },
        methods:{
            saveData:  async function(){
                let data = [];
                await Object.keys(this.fields).map(f => {
                    data = data.concat(this.fields[f])
                })
                await this.$store.dispatch("adfields_edit", {details: data})
                if(this.$store.getters.getLDAPStatus.status == "Success"){
                    await this.$store.dispatch("adfields_get")
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/ADField.vue